import type { ReactNode } from 'react';

/**
 * A quiz in miniature, on the real card's own `.sf-quiz-card`. Lines rather than
 * words: a question this provider never asked would make the card a claim about
 * content, and it only ever claims there is somewhere to get in.
 */
function QuizPreview() {
  return (
    <div
      aria-hidden
      className="sf-quiz-card flex flex-col gap-2 rounded-[10px] p-3"
    >
      <span className="h-2 w-1/3 rounded-full bg-white/45" />
      <span className="flex flex-col gap-1">
        <span className="h-3 w-[86%] rounded-full bg-white/70" />
        <span className="h-3 w-[54%] rounded-full bg-white/70" />
      </span>
      <span className="mt-0.5 flex flex-col gap-1.5">
        <span className="flex h-7 items-center rounded-lg bg-white/95 px-2.5">
          <span className="h-2 w-[46%] rounded-full bg-[var(--sf-line)]" />
        </span>
        <span className="flex h-7 items-center rounded-lg bg-white/95 px-2.5">
          <span className="h-2 w-[34%] rounded-full bg-[var(--sf-line)]" />
        </span>
      </span>
    </div>
  );
}

/**
 * The quiz column's empty state, and the owner reads it too — their slot is a
 * preview of the public page. It asks for nothing: an ask here speaks for a
 * quiz that may never be written.
 * See the storefront section of the root CLAUDE.md.
 */
export function QuizWaitCard({ tutorName }: { tutorName: string }) {
  return <WaitShell>{tutorName} hasn&rsquo;t posted a quiz yet</WaitShell>;
}

function WaitShell({ children }: { children: ReactNode }) {
  return (
    <div className="overflow-hidden rounded-[var(--sf-radius)] bg-[var(--sf-card)]">
      <div className="relative flex flex-col gap-2 px-3.5 pt-3.5">
        <QuizPreview />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-10 bg-gradient-to-b from-transparent to-[var(--sf-card)]" />
      </div>

      <div className="flex flex-col gap-2 px-3.5 pb-3.5 pt-3">
        <span className="sf-title text-title-2 font-extrabold text-[var(--sf-ink)]">
          {children}
        </span>
      </div>
    </div>
  );
}
